export default {
  edit: 'Edit',
  editTitle: 'Edit Robot Dog Info',
  cancel: 'Cancel',
  confirm: 'Confirm',
  fieldSn: 'Device SN',
  fieldAlias: 'Alias',
  fieldNameEn: 'Alias (EN)',
  fieldDeviceType: 'Device Type',
  fieldLongitude: 'Longitude',
  fieldLatitude: 'Latitude',
  placeholderSn: 'Enter device SN',
  placeholderAlias: 'Enter alias',
  placeholderNameEn: 'Enter English alias',
  placeholderDeviceType: 'Enter device type',
  placeholderLongitude: 'Enter longitude (optional)',
  placeholderLatitude: 'Enter latitude (optional)',
  ruleSn: 'Please enter device SN',
  ruleAlias: 'Please enter alias',
  ruleNameEn: 'Please enter English alias',
  ruleDeviceType: 'Please enter device type',
  successUpdate: 'Updated successfully',
  failUpdate: 'Update failed',
}
